import React from "react";
import styles from './SpaceInfo.module.scss';
import { Reviews } from "./Reviews/Reviews";
import { Amenities } from "./Amenities/Amenities";
import { Overview } from "./Overview/Overview";
import { MonthlyPrice, Review, TransportationLinks } from "common/types/search";

interface Props {
  resources: string[];
  view: string;
  monthlyPrice?: MonthlyPrice[];
  transportation_links: TransportationLinks;
  country: string;
  description: string;
  amenities_ids: string;
  reviews_full: Review[];
  header: string;
}

const SpaceInfo:React.FC<Props> = ({
  resources = [],
  view = 'list',
  monthlyPrice = [],
  transportation_links = [],
  country = '',
  description = '',
  amenities_ids = '',
  reviews_full = [],
  header = '',
}) => {

  const [infoType, setInfoType] = React.useState<string>('overview');

  const onInfoTypeChange = (e: React.MouseEvent<HTMLButtonElement>, type: string) => {
    e.stopPropagation();
    setInfoType(type);
  }

  const stopBubbling = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.container} onClick={(e) => stopBubbling(e)}>
      <div className={styles.infoTypeContainer}>
        <button className={infoType === 'overview' ? styles.active : ''} onClick={(e) => onInfoTypeChange(e, 'overview')}>Overview</button>
        <button className={infoType === 'amenities' ? styles.active : ''} onClick={(e) => onInfoTypeChange(e, 'amenities')}>Amenities</button>
        <button className={infoType === 'reviews' ? styles.active : ''} onClick={(e) => onInfoTypeChange(e, 'reviews')}>Reviews 
          {reviews_full.length > 0 && <span className={styles.reviews_count}>{reviews_full.length}</span>}
        </button>
      </div>
      <div className={styles.content}>
        {infoType === "overview" ? (
          <Overview
            resources={resources}
            view={view}
            monthlyPrice={monthlyPrice}
            transportation_links={transportation_links}
            country={country}
            description={description}
            header={header}
            reviews_full={reviews_full}
          />
        ) : infoType === "amenities" ? (
          <>
            <Amenities amenities_ids={amenities_ids} />
          </>
        ) : (
          <Reviews reviews_full={reviews_full} />
        )}
    </div>
    </div>
  )
}

export default SpaceInfo;